import { controls, currencyToNumber, grouped } from "../../controls";

const late_comers = {
  label: "Late Comers",
  starting: true,
  url: "rp101m",
  pageLabel: "Late Comers",
  pageType: "history",
  visitingBranches: true,
  filter: [
    ...controls.magicDateLabel({ tab: "general", label: "DATE", target: "as_on_date", star: true }),
    ...controls.magicDate({
      tab: "general", name: "as_on_date", dateType: "ontype", isRequired: true, default
        : "n"
    }),
    ...controls.displayText({ tab: "general", label: "" }),

    ...controls.displayText({ tab: "general", label: "Time", star: true }),
    ...controls.floatOnly({ tab: "general", placeHolder: "", name: "time", placeHolder: "HH:MM", isRequired: true, maxlength: 5, isReadOnly: "edit" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Late Comers",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Employee Code",
        accessor: "employee_code",
        rwidth: "*"
      },
      {
        Header: "Name",
        accessor: "employee_display",
        rwidth: "*"
      },
      {
        Header: "In Time",
        accessor: "in_time"
      }
    ]
  }
};

export default late_comers;